export default function BackGallery({ className, onClick }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" fill="none" className={className}>
      <path
        stroke="#F7F7F8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m23 27-7-7 7-7"
      />
    </svg>
  );
}
